import axios from 'axios';
import apisUrls from '../urls';

const deleteAdminApi = (values) => {
  return axios.delete(`${apisUrls?.deleteAdmin}?admin_id=${values}`);
};

export default deleteAdminApi;
